import { reverseDate } from '../general/Utilities';
export var isValidDate = function isValidDate(value) {
  // data format - dd/mm/yyyy
  var rxDatePattern = /^(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})$/; //Declare Regex

  var dtArray = value.match(rxDatePattern); // is format OK?

  if (dtArray == null) {
    return false;
  } //Checks for mm/dd/yyyy format.


  var dtMonth = dtArray[3];
  var dtDay = dtArray[1];
  var dtYear = dtArray[5];
  var check = true;
  if (dtMonth < 1 || dtMonth > 12) check = false;else if (dtDay < 1 || dtDay > 31) check = false;else if ((dtMonth == 4 || dtMonth == 6 || dtMonth == 9 || dtMonth == 11) && dtDay == 31) check = false;else if (dtMonth == 2) {
    var isleap = dtYear % 4 == 0 && (dtYear % 100 != 0 || dtYear % 400 == 0);
    if (dtDay > 29 || dtDay == 29 && !isleap) check = false;
  }

  if (!check) {
    return false;
  }

  return {
    day: dtDay,
    month: dtMonth,
    year: dtYear
  };
};
export var TextValidator = function TextValidator(value, minLength) {
  if (value.length < minLength) {
    return {
      status: false,
      msg: 'Minim ' + minLength + ' caractere'
    };
  } else {
    return {
      status: true,
      msg: ''
    };
  }
};
export var TextOnlyValidator = function TextOnlyValidator(value, minLength) {
  if (value.length < minLength) {
    return {
      status: false,
      msg: 'Minim ' + minLength + ' caractere'
    };
  } else if (/\d/.test(value)) {
    return {
      status: false,
      msg: 'Completează doar litere'
    };
  } else {
    return {
      status: true,
      msg: ''
    };
  }
};
export var DateField = function DateField(value) {
  //format dd-mm-yyyy 
  if (isValidDate(value)) {
    var currentDate = new Date();

    if (currentDate < new Date(reverseDate(value))) {
      return {
        status: false,
        msg: 'Nu se pot introduce valori din viitor'
      };
    }

    return {
      status: true,
      msg: ''
    };
  }

  return {
    status: false,
    msg: 'Dată incorectă'
  };
};
export var SelectField = function SelectField(value) {
  if (value == '') {
    return {
      status: false,
      msg: 'Alege o opțiune'
    };
  }

  return {
    status: true,
    msg: ''
  };
};
export var RoPhoneField = function RoPhoneField(value) {
  if (isValidRomanianPhone(value)) {
    return {
      status: true,
      msg: ''
    };
  } else {
    return {
      status: false,
      msg: 'Completează un număr corect de telefon mobil'
    };
  }
};
export var isValidRomanianPhone = function isValidRomanianPhone(phone_number) {
  phone_number = phone_number.replace(/\(|\)|\s+|-/g, "");

  if (phone_number.length > 9 && phone_number.match(/^(?:(?:(?:00\s?|\+)40\s?|0)(?:7\d{2}\s?\d{3}\s?\d{3}|(21|31)\d{1}\s?\d{3}\s?\d{3}|((2|3)[3-7]\d{1})\s?\d{3}\s?\d{3}|(8|9)0\d{1}\s?\d{3}\s?\d{3}))$/)) {
    return true;
  } else return false;
};
export var EmptyField = function EmptyField() {
  return {
    status: true,
    msg: ''
  };
};